export default __webpack_public_path__ + "static/media/cleanpro_midnight_magic_hours.a9c33dd8.png";